var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "app-container" }, [
    _vm.list.length || !_vm.listLoading
      ? _c(
          "div",
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.listLoading,
                    expression: "listLoading",
                  },
                ],
                attrs: {
                  data: _vm.filteredList,
                  "element-loading-text": "Loading...",
                  border: "",
                  fit: "",
                  "highlight-current-row": "",
                },
              },
              [
                _c("el-table-column", {
                  attrs: { align: "center", label: "Platform", width: "120" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "el-tag",
                              { attrs: { type: _vm.getOSTagType(row.os) } },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.getOSName(row.os)) + " "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    135988739
                  ),
                }),
                _c("el-table-column", {
                  attrs: { label: "Version", align: "center", width: "150" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [_c("strong", [_vm._v(_vm._s(row.version))])]
                        },
                      },
                    ],
                    null,
                    false,
                    578652161
                  ),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "Force Update",
                    align: "center",
                    width: "150",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type: row.isMajor ? "danger" : "success",
                                },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(row.isMajor ? "Yes" : "No") + " "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    1785894200
                  ),
                }),
                _c("el-table-column", {
                  attrs: { label: "Store URL", align: "center" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "a",
                              {
                                staticStyle: { color: "#409EFF" },
                                attrs: { href: row.storeUrl, target: "_blank" },
                              },
                              [_vm._v(" " + _vm._s(row.storeUrl || "-") + " ")]
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    279610660
                  ),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "Actions",
                    align: "center",
                    width: "120",
                    "class-name": "fixed-width",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { size: "mini", type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleUpdate(row)
                                  },
                                },
                              },
                              [_vm._v(" Edit ")]
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    3735381397
                  ),
                }),
              ],
              1
            ),
            _c(
              "el-dialog",
              {
                attrs: {
                  title: "Edit Store Version",
                  visible: _vm.dialogFormVisible,
                  width: "40%",
                },
                on: {
                  "update:visible": function ($event) {
                    _vm.dialogFormVisible = $event
                  },
                },
              },
              [
                _c(
                  "el-form",
                  {
                    ref: "dataForm",
                    attrs: {
                      rules: _vm.rules,
                      model: _vm.tempVersionData,
                      "label-position": "left",
                      "label-width": "150px",
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "Platform" } },
                      [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.getOSTagType(_vm.tempVersionData.os),
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.getOSName(_vm.tempVersionData.os)) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "Version", prop: "version" } },
                      [
                        _c("el-input-number", {
                          staticStyle: { width: "100%" },
                          attrs: { min: 0, step: 1 },
                          model: {
                            value: _vm.tempVersionData.version,
                            callback: function ($$v) {
                              _vm.$set(_vm.tempVersionData, "version", $$v)
                            },
                            expression: "tempVersionData.version",
                          },
                        }),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "font-size": "12px",
                              color: "#909399",
                              display: "block",
                              "margin-top": "5px",
                            },
                          },
                          [_vm._v(" App version number (e.g., 1, 2, 3, etc.) ")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "Force Update", prop: "isMajor" } },
                      [
                        _c("el-switch", {
                          attrs: {
                            "active-text": "Yes - Users must update",
                            "inactive-text": "No - Optional update",
                          },
                          model: {
                            value: _vm.tempVersionData.isMajor,
                            callback: function ($$v) {
                              _vm.$set(_vm.tempVersionData, "isMajor", $$v)
                            },
                            expression: "tempVersionData.isMajor",
                          },
                        }),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "font-size": "12px",
                              color: "#909399",
                              display: "block",
                              "margin-top": "5px",
                            },
                          },
                          [
                            _vm._v(
                              " When enabled, users will be forced to update to this version "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "Store URL", prop: "storeUrl" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "App Store or Play Store URL" },
                          model: {
                            value: _vm.tempVersionData.storeUrl,
                            callback: function ($$v) {
                              _vm.$set(_vm.tempVersionData, "storeUrl", $$v)
                            },
                            expression: "tempVersionData.storeUrl",
                          },
                        }),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "font-size": "12px",
                              color: "#909399",
                              display: "block",
                              "margin-top": "5px",
                            },
                          },
                          [
                            _vm._v(
                              " Direct link to download the app from the store "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "dialog-footer",
                    attrs: { slot: "footer" },
                    slot: "footer",
                  },
                  [
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function ($event) {
                            _vm.dialogFormVisible = false
                          },
                        },
                      },
                      [_vm._v(" Cancel ")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.updateData()
                          },
                        },
                      },
                      [_vm._v(" Save Changes ")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      : _c("div", { staticClass: "empty-state" }, [
          _c("p", [_vm._v("Loading store version information...")]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }